import { render, staticRenderFns } from "./zyQiuzDetail.vue?vue&type=template&id=cf336428&scoped=true"
import script from "./zyQiuzDetail.vue?vue&type=script&lang=js"
export * from "./zyQiuzDetail.vue?vue&type=script&lang=js"
import style0 from "./zyQiuzDetail.vue?vue&type=style&index=0&id=cf336428&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf336428",
  null
  
)

export default component.exports